export const Content ={
    BANNER_HEADING: "Welcome to the Workplace options CPQ",
    BANNER_PARA: "CPQ platform! Simplify your process with intuitive, powerful, and customizable Configure-Price-Quote solution." ,
    QUOTE_REQUEST: "Quote Requests",
    CREATE_REQUEST: "Create Request",
    VISUALIZE: "Visualize",
    ACCOUNT_NAME: "Account Name :",
    NAME: "Lorem Ipsum",
    OPP_NAME: "Opportunity Name :",
    OPP_ID: "Opportunity ID :",
    ALL:'All',
    SUBMITTED: 'Save as draft',
    PENDING_PRICING: 'Pending Pricing Team',
    PENDING_APPROVAL: 'Pending SAM Leadership',
    APPROVED: 'Approved',
    CONTRACTED: 'Contracted',
    CLOSE_CONTRACTED: 'Closed',
    PENDING_REQUESTOR: 'Pending Initial Requestor',
    PENDING_PRICINGMANAGER: 'Pricing Manager',
    PENDING_PRICINGVP: 'Pricing VP',
    PENDING_PRICINGMANAGERANDSAMLEADERSHIP: 'Pricing Manager and SAM Leadership',
    PENDING_PRICINGVPANDSAMLEADERSHIP: 'Pricing VP and SAM Leadership',
    INITALPAGENO:1

}